import api from '@/lib/api';
import type { PageResponse } from '@/types/admin.model';
import { toPageResponse } from '@/types/admin.model';

/**
 * Shape fixed by the backend: GET /payments/debtors/admin builds its own DTO by
 * hand instead of projecting a model, so there is no `fields` param to send.
 *
 * `debt` arrives as a number, not the Double of the in-memory getter: the
 * backend sums it in SQL precisely so the board and the app agree.
 */
export interface AdminDebtor {
  pk: string;
  name: string;
  email: string;
  debt: number;
  hasPendingRequest: boolean;
}

interface ListParams {
  query?: string;
  page: number;
  size: number;
}

export const adminDebtorsApi = {
  list: async ({
    query,
    page,
    size,
  }: ListParams): Promise<PageResponse<AdminDebtor>> => {
    const response = await api.get('/payments/debtors/admin', {
      params: {
        query: query || undefined,
        page,
        size,
      },
    });
    return toPageResponse<AdminDebtor>(response.data);
  },
};
